module.exports = __webpack_public_path__ + "img/article-1.c4887caf.jpg";